import { ECreateQuestionMode } from './context/create-question.context';

const EDIT_MODES = [ECreateQuestionMode.Edit, ECreateQuestionMode.InTemplateEdit];

/** Whether saving would update a question the user has no update rights on. Unknown rights count as allowed. */
export const lacksQuestionUpdatePermission = (
  mode: ECreateQuestionMode,
  hasQuestionUpdatePermission: boolean | undefined,
): boolean => EDIT_MODES.includes(mode) && hasQuestionUpdatePermission === false;
